import _ from 'lodash';
import React from 'react';

import {
  LeaseApplicationStepNameName,
  useLeaseApplicationStepNameSelectFieldQuery
} from 'generated/graphql';



export interface ILeaseApplicationStepName {
  id: LeaseApplicationStepNameName;
  displayName: string;
}

export interface IData {
  objects: ILeaseApplicationStepName[];
}

export function useQuery() {
  const queryTuple = useLeaseApplicationStepNameSelectFieldQuery();

  const wrappedTuple = React.useMemo(() => {
    const data: IData = {
      objects: _.map(queryTuple.data?.smartPayLeaseApplicationStepNames ?? [], (node): ILeaseApplicationStepName => ({
        id: node.name,
        displayName: node.displayName
      }))
    };

    return {
      loading: queryTuple.loading,
      data,
      refetch: async () => {
        queryTuple.refetch({});
      }
    };
  }, [queryTuple]);

  return wrappedTuple;
}
